export enum EnergyTechnologyAPIResponse {
  Solar = 'Solar',
  Storage = 'Storage',
  SolarAndStorage = 'SolarAndStorage',
}
